import React from 'react';
import PropTypes from 'prop-types';
import './SelectedCategoryInfo.css';

/**
 * Selected Category Info component
 * Displays the selected event category name and description above event cards
 */
const SelectedCategoryInfo = ({ categoryName, description }) => {
    if (!categoryName) {
        return null;
    }

    return (
        <div className="selected-category-info">
            {/* Category Banner */}
            <div className="selected-category-info__banner">
                <h2 className="selected-category-info__title">
                    {categoryName}
                </h2>
            </div>
            
            {/* Description commented on 1704 */}
            {/* {description && (
                <div className="selected-category-info__description">
                    <p>{description}</p>
                </div>
            )} */}
        </div>
    );
};

SelectedCategoryInfo.propTypes = {
    categoryName: PropTypes.string,
    description: PropTypes.string
};

SelectedCategoryInfo.defaultProps = {
    categoryName: '',
    description: ''
};

export default SelectedCategoryInfo;

